import { render, staticRenderFns } from "./ItemFlawSummary.vue?vue&type=template&id=dffc10c0&scoped=true"
import script from "./ItemFlawSummary.vue?vue&type=script&lang=js"
export * from "./ItemFlawSummary.vue?vue&type=script&lang=js"
import style0 from "./ItemFlawSummary.vue?vue&type=style&index=0&id=dffc10c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffc10c0",
  null
  
)

export default component.exports